
import React, { useState, useEffect } from 'react';
import { Tooltip, Dialog, DialogTitle, Grid, DialogContent, TextField, FormHelperText, Checkbox, Chip, DialogActions } from "@mui/material";
import { RuleModel, RuleStatus, RuleType, RuleDurationType, RuleDurationDays, RuleDuration, } from '../../models/auto-alert.model';
import { TemplateModel } from '../../models/templates.models';
import { buttonLabels, ToasterTexts, WeekDaysLabel } from '../shared/constants';
import DateAndTimePicker from '../shared/datetimepicker/date-timepicker.component';
import { validateForm } from '../shared/form-validation';
import ButtonComponent from '../shared/button/button.component';
import ArrowTimePicker from '../shared/datetimepicker/arrow-timepicker.component';
import MessageComposer from '../conversations/message-composer';
import setToast from '../../helpers/toaster.helper';
import { AutoAlertRulesService } from '../../services/AutoAlertRulesService';
import { ToasterType } from '../shared/toaster/toaster.model';
import { UtilityService } from '../../services/UtilityService';
import { LoadTemplates } from '../../actions';
import { BackMobileIcon, CancelIcon, DisableResetIcon, ResetIcon } from '../../icon';
import { MediaModel } from '../../models/conversations';
import { Autocomplete, createFilterOptions } from '@mui/material';
import { useSelector } from 'react-redux';
import { isDarkMode, isMobileDevice, templates } from '../../selectors/selectors';
import { useDispatch } from 'react-redux';
import CustomSwitch from '../shared/switch.component';

let keywordtype = [{ Name: "Auto Reply", Value: RuleType.AUTO_REPLY }, { Name: "Keyword", Value: RuleType.KEYWORD }];
let durationType = [{ Name: "Fixed Duration", Value: RuleDurationType.FIXED_DURATION }, { Name: "Repeat Daily", Value: RuleDurationType.REPEAT_DAILY }, { Name: "Repeat Weekly", Value: RuleDurationType.REPEAT_WEEKLY }, { Name: "Repeat Monthly", Value: RuleDurationType.REPEAT_MONTHLY }, { Name: "Always", Value: RuleDurationType.ALWAYS }]
let weekDays = [{ label: WeekDaysLabel.SUNDAY, value: RuleDurationDays.SUNDAY }, { label: WeekDaysLabel.MONDAY, value: RuleDurationDays.MONDAY }, { label: WeekDaysLabel.TUESDAY, value: RuleDurationDays.TUESDAY }, { label: WeekDaysLabel.WEDNESDAY, value: RuleDurationDays.WEDNESDAY }, { label: WeekDaysLabel.THURSDAY, value: RuleDurationDays.THURSDAY }, { label: WeekDaysLabel.FRIDAY, value: RuleDurationDays.FRIDAY }, { label: WeekDaysLabel.SATURDAY, value: RuleDurationDays.SATURDAY },]

interface IProps {
    OnClose: (confirm: boolean) => void;
    Show: boolean;
    Rule?: RuleModel;
    PageTitle?: string;
    ButtonLabel?: string;
    HandleSubmitSuccess?: (e: any) => void;
    ShowLoader?: boolean;
    IsUploading?: boolean;
    IsAutoReply?: boolean;
}

interface IState {
    Title: string;
    ID: string;
    Name: string;
    Type: RuleType | -1;
    Status: RuleStatus;
    Message: string;
    IsOneTime: boolean;
    Duration: RuleDuration;
    PhoneNumbers: string[];
    ParentRuleId: string;
    CreatedBy: string;
    CreatedDateTime: string;
    IsLiveToday: boolean;
    Media?: MediaModel[];
    IsDeleted: boolean;
    errors: {
        Name: string;
        Message: string;
        ParentRuleId: string;
        PhoneNumberId: string;
        Type: string;
        Days: string;
        DurationType: string;[key: string]: any;
        StartTime: string;
        EndTime: string;
        MonthDate: string;
        Keyword: string;
    };
    [key: string]: any;
    IsLoading: boolean;
    MessageLength: number;
    mediaReferenceID: string;
    charLimit: number;
    Keyword: string;
    isKeyWordOptIn: boolean
}

const AddRuleComponent: React.FC<IProps> = (props) => {
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(isMobileDevice)
    const IsDarkMode: boolean = useSelector(isDarkMode)
    const Templates: TemplateModel[] = useSelector(templates)
    const Autofilter = createFilterOptions();
    const [state, setState] = useState<IState>(getInitState());

    useEffect(() => {
        setState(getInitState());
    }, [props.Rule]);

    function getInitState(): IState {
        return {
            ...(props.Rule ? {
                ID: props.Rule?.ID || "", Name: props.Rule?.Name || "", CreatedBy: props.Rule?.CreatedBy || "", CreatedDateTime: props.Rule?.CreatedDateTime || "", IsLiveToday: !!props.Rule?.IsLiveToday, IsOneTime: !!props.Rule?.IsOneTime, Message: props.Rule?.Message || "", ParentRuleId: props.Rule?.ParentRuleId || "", PhoneNumbers: props.Rule?.PhoneNumbers || [], Type: props.Rule?.Type, IsDeleted: !!props.Rule?.IsDeleted, Status: props.Rule?.Status || 0, Duration: { Days: props.Rule?.Duration?.Days || [], DurationType: props.Rule?.Duration?.DurationType || RuleDurationType.FIXED_DURATION, EndDateTime: props.Rule?.Duration?.EndDateTime ? UtilityService.convertToPreferredTimeZone(props.Rule?.Duration?.EndDateTime) : -1, StartDateTime: props.Rule?.Duration?.StartDateTime ? UtilityService.convertToPreferredTimeZone(props.Rule?.Duration?.StartDateTime) : -1 }, Media: props.Rule?.Media,
                MonthDate: Number(UtilityService.convertToPreferredTimeZone((new Date().getMonth() + 1) + '-' + props.Rule?.Duration?.Days.toString() + '-' + new Date().getFullYear())), Keyword: props.Rule?.Keyword || "", isKeyWordOptIn: props.Rule?.IsKeyWordOptIn || false
            } :
                {
                    ID: "", Name: "", CreatedBy: "", MonthDate: -1, CreatedDateTime: "", IsLiveToday: false, IsOneTime: true, Message: "", ParentRuleId: "", PhoneNumbers: [], Type: props.IsAutoReply ? RuleType.AUTO_REPLY : RuleType.KEYWORD, IsDeleted: false, Status: 0, Duration: { Days: [], DurationType: RuleDurationType.FIXED_DURATION, EndDateTime: -1, StartDateTime: -1 }, Media: [], mediaReferenceID: "", Keyword: "", isKeyWordOptIn: false
                }),
            Title: props.PageTitle,
            errors: {
                Name: "", Message: "", ParentRuleId: "", PhoneNumberId: "", Type: "", Days: "", DurationType: "", StartTime: "", EndTime: "", MonthDate: "", Keyword: ""
            },
            IsLoading: false, MessageLength: 0, IsUploading: false, charLimit: 160
        } as IState;
    }
    const handleChange = (name, value) => {
        validateForm({ [name]: value }, (errors) => {
            setState((prevState) => ({
                ...prevState,
                errors: {
                    ...prevState.errors,
                    ...errors,
                },
            }));
        });
        setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleStartTimeDate = (dateTime: number) => {
        setState((prev) => ({
            ...prev,
            Duration: {
                ...prev.Duration,
                StartDateTime: dateTime,
                EndDateTime: -1,
            },
            errors: {
                ...prev.errors,
                StartTime: "",
            },
        }));
    }

    const handleEndTimeDate = (dateTime: number) => {
        setState((prev) => ({
            ...prev,
            Duration: {
                ...prev.Duration,
                EndDateTime: dateTime,
            },
            errors: {
                ...prev.errors,
                EndTime: "",
            },
        }));
    };

    const ResetDateTime = (property) => {
        setState((prevState) => ({
            ...prevState,
            Duration: {
                ...prevState.Duration,
                [property]: -1,
            },
        }));
    };

    const ResetStartDateTime = () => {
        ResetDateTime('StartDateTime');
    };

    const ResetEndDateTime = () => {
        ResetDateTime('EndDateTime');
    };

    const handleMonthDate = (scheduleTimeDate) => {
        setState((prevState) => ({
            ...prevState,
            MonthDate: scheduleTimeDate,
            Duration: {
                ...prevState.Duration,
                Days: [new Date(scheduleTimeDate).getDate()],
            },
            errors: {
                ...prevState.errors,
                MonthDate: "",
            },
        }));
    };

    const handleClearOptions = () => {
        setState((prev) => ({
            ...prev,
            Duration: { ...prev.Duration, Days: [] },
        }));
    };

    const handleSelectAll = (isSelected: boolean) => {
        setState((prev) => ({
            ...prev,
            Duration: {
                ...prev.Duration,
                Days: isSelected
                    ? weekDays.map((x) => x.value)
                    : [],
            },
        }));
    };

    const handleSelectDaysChange = (event: any, selectedOptions: any[], reason: string) => {
        if (reason === "selectOption" || reason === "removeOption") {
            const selectedDays = weekDays.length === state.Duration.Days.length;
            if (selectedOptions.find((option) => option.value === -1)) {
                setState((prev) => ({ ...prev, Duration: { ...prev.Duration, Days: weekDays.map((day) => day.value), }, errors: { ...prev.errors, Days: "" } }));
                if (selectedDays === true) {
                    handleSelectAll(!selectedDays)
                    setState((prev) => ({ ...prev, errors: { ...prev.errors, Days: "Days cannot be blank" } }));
                }
            } else {
                setState((prev) => ({ ...prev, Duration: { ...prev.Duration, Days: [...selectedOptions.map((x) => x.value)] }, errors: { ...prev.errors, Days: "" } }));
                if (state.Duration.Days.length === 1 && reason === "removeOption") {
                    setState((prev) => ({ ...prev, errors: { ...prev.errors, Days: "Days cannot be blank" } }));
                }
            }
        } else if (reason === "clear") {
            handleClearOptions();
        }
    };

    const optionRenderer = (defaultprops, option: any, { selected }: any) => {
        const selectAllProps =
            weekDays.length > 0 && option.value === -1
                ? { checked: weekDays.length === state.Duration.Days.length }
                : {};
        return (
            <li {...defaultprops} className={"h6 d-flex w-p-100"}>
                <Checkbox
                    name="checkbox"
                    className="mr-1"
                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                    indeterminate={option.value === -1 && weekDays.length - 1 === state.Duration.Days.length}
                    checked={selected}
                    {...selectAllProps}
                />
                <div className={`my-auto t-align-left`}> {option?.label} </div>
            </li >
        )
    }

    const inputRenderer = (params: any) => (
        <TextField
            className={`bg-color-secondary color-display-title`}
            {...params}
            label={"Select Days"}
            variant="outlined"
            fullWidth
        />
    );

    const valueRefresher = (val: any) => {
        setState((prev) => ({
            ...prev,
            errors: {
                ...prev.errors,
                StartTime: "",
                EndTime: "",
                Days: "",
                MonthDate: "",
                Type: "",
                DurationType: "",
            },
            Duration: {
                ...prev.Duration,
                StartDateTime: -1,
                EndDateTime: -1,
                Days: [],
                DurationType: val.Value,
            },
            MonthDate: -1,
        }));
    };


    const formSubmit = (e: any) => {
        e.preventDefault();
        const scheduledateAndTimeValid = state.Type === RuleType.AUTO_REPLY && state.Duration?.DurationType === RuleDurationType.FIXED_DURATION && new Date(state.Duration?.EndDateTime) <= UtilityService.getPreferredTimeZoneTimeNow();
        const TimeValid = state.Type === RuleType.AUTO_REPLY && (state.Duration?.DurationType !== RuleDurationType.ALWAYS && state.Duration?.EndDateTime <= state.Duration?.StartDateTime || (state.Duration?.StartDateTime as any) >= UtilityService.convertToDateTimeFormat(state.Duration?.EndDateTime));
        const monthDateValid = state.Type === RuleType.AUTO_REPLY && state.Duration?.DurationType === RuleDurationType.REPEAT_MONTHLY && state.MonthDate === -1;
        const dateTimeValid = state.Type === RuleType.AUTO_REPLY && state.Duration?.DurationType !== (RuleDurationType.ALWAYS || RuleDurationType.REPEAT_MONTHLY) && (state.Duration.EndDateTime === -1 || state.Duration.StartDateTime === -1);
        validateForm(state.Type === RuleType.KEYWORD
            ? { Name: state.Name, Type: state.Type, Keyword: state.Keyword }
            : state.Type === RuleType.AUTO_REPLY && (state.Duration.DurationType === RuleDurationType.FIXED_DURATION || state.Duration.DurationType === RuleDurationType.ALWAYS)
                ? { Name: state.Name, Type: state.Type, DurationType: state.Duration?.DurationType, Message: state.Message }
                : { Name: state.Name, Days: state.Duration.Days, StartTime: state.Duration?.StartDateTime, EndTime: state.Duration?.EndDateTime, Message: state.Message },
            (errors) => {
                if (monthDateValid) {
                    setState((prev) => ({
                        ...prev,
                        errors: { ...prev.errors, ...errors, MonthDate: "monthdate cannot be blank" },
                    }));
                } else if (dateTimeValid) {
                    state.Duration.StartDateTime === -1 &&
                        setState((prev) => ({
                            ...prev,
                            errors: { ...prev.errors, ...errors, StartTime: "Start Time cannot be blank" },
                        }));
                    state.Duration.EndDateTime === -1 &&
                        setState((prev) => ({
                            ...prev,
                            errors: { ...prev.errors, ...errors, EndTime: "End Time cannot be blank" },
                        }));
                    state.Duration.StartDateTime === -1 &&
                        state.Duration.EndDateTime === -1 &&
                        setState((prev) => ({
                            ...prev,
                            errors: {
                                ...prev.errors,
                                ...errors,
                                StartTime: "Start Time cannot be blank",
                                EndTime: "End Time cannot be blank",
                            },
                        }));
                } else if ((TimeValid || scheduledateAndTimeValid) && !dateTimeValid) {
                    setToast(ToasterTexts.SCHEDULED_MESSAGE_PASTDATETIME, ToasterType.DANGER);
                } else if (
                    !!state.Media?.length ?
                        validateForm(
                            state.Type === RuleType.KEYWORD
                                ? { Name: state.Name, Type: state.Type, Keyword: state.Keyword }
                                : state.Type === RuleType.AUTO_REPLY &&
                                    (state.Duration.DurationType === RuleDurationType.FIXED_DURATION ||
                                        state.Duration.DurationType === RuleDurationType.ALWAYS)
                                    ? { Name: state.Name, Type: state.Type, DurationType: state.Duration?.DurationType }
                                    : { Name: state.Name, Days: state.Duration.Days, StartTime: state.Duration?.StartDateTime, EndTime: state.Duration?.EndDateTime, Type: state.Type },
                            (errors) => {
                                setState((prev) => ({ ...prev, errors: { ...prev.errors, ...errors } }));
                            }
                        ) &&
                        !scheduledateAndTimeValid
                        :
                        validateForm(
                            state.Type === RuleType.KEYWORD
                                ? { Name: state.Name, Type: state.Type, Message: state.Message, Keyword: state.Keyword }
                                : state.Type === RuleType.AUTO_REPLY &&
                                    (state.Duration.DurationType === RuleDurationType.FIXED_DURATION ||
                                        state.Duration.DurationType === RuleDurationType.ALWAYS)
                                    ? { Name: state.Name, Type: state.Type, DurationType: state.Duration?.DurationType, Message: state.Message }
                                    : { Name: state.Name, Days: state.Duration.Days, StartTime: state.Duration?.StartDateTime, EndTime: state.Duration?.EndDateTime, Message: state.Message, Type: state.Type },
                            (errors) => {
                                setState((prev) => ({ ...prev, errors: { ...prev.errors, ...errors } }));
                            }
                        ) &&
                        !scheduledateAndTimeValid
                ) {
                    setState((prev) => ({ ...prev, IsLoading: true }));
                    const days = state.Duration?.Days;
                    const obj: any = {
                        id: state.ID || undefined,
                        name: state.Name,
                        type: state.Type,
                        status: state.ID ? getStatus() : undefined,
                        message: state.Message,
                        isRecurring: false,
                        duration: state.Type === RuleType.KEYWORD ? undefined : {
                            durationType: state.Duration.DurationType,
                            startDateTime: state.Duration.StartDateTime ? UtilityService.convertToLocalTimeZone(state.Duration.StartDateTime).toISOString() : undefined,
                            endDateTime: state.Duration.EndDateTime ? UtilityService.convertToLocalTimeZone(state.Duration.EndDateTime).toISOString() : undefined, days: days,
                        },
                        // phoneNumberList: state.ID ? [state.PhoneNumberId] : [],
                        parentRuleId: state.ParentRuleId ? state.ParentRuleId : undefined,
                        media: !!state.Media?.length ? state.Media : undefined,
                        isKeywordOptIn: state.isKeyWordOptIn,
                        keyword: state.Type === RuleType.KEYWORD ? state.Keyword : null,
                    };

                    if (!!state.ID) {
                        AutoAlertRulesService.updateAutoAlertRule(obj)
                            .then(() => {
                                if (props.HandleSubmitSuccess) {
                                    props.HandleSubmitSuccess(e);
                                }
                                props.ButtonLabel === "Start"
                                    ? setToast(ToasterTexts.AUTO_ALERT_RULE_START_SUCCESS.replace('<Name>', state.Name), ToasterType.SUCCESS)
                                    : setToast(ToasterTexts.AUTO_ALERT_RULE_UPDATE_SUCCESS.replace('<Name>', state.Name), ToasterType.SUCCESS);
                                props.OnClose(true);
                            })
                            .catch((err) => {
                                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                                setState((prev) => ({ ...prev, IsLoading: false }));
                            });
                    } else {
                        AutoAlertRulesService.createAutoAlertRule(obj)
                            .then((res) => {
                                props.HandleSubmitSuccess(e);
                                setState((prev) => ({ ...prev, IsLoading: false }));
                                setToast(ToasterTexts.AUTO_ALERT_RULE_ADD_SUCCESS.replace('<Name>', state.Name), ToasterType.SUCCESS);
                                props.OnClose(true);
                            })
                            .catch((err) => {
                                setToast(err.response.data.message, ToasterType.DANGER);
                                setState((prev) => ({ ...prev, IsLoading: false }));
                            });
                    }
                }
                else {
                    // Handle other cases if needed
                }
            }
        );
    };

    const getStatus = () => {
        return state.Status === RuleStatus.COMPLETED &&
            state.Duration?.EndDateTime > UtilityService.getPreferredTimeZoneTimeNow().getTime()
            ? RuleStatus.ACTIVE
            : state.Status;
    };

    const handleMessageChanges = (data: { body: string; media: MediaModel[], bodyLength: number, characterLimit: number }) => {
        if (data.body?.length < 1 && data.media?.length < 1 && (data.body !== state.Message || data.media?.length !== state?.Media?.length)) {
            setState((prev) => ({
                ...prev,
                Message: data.body,
                Media: data.media,
                MessageLength: data.bodyLength,
                charLimit: data.characterLimit,
                errors: { ...prev.errors, Message: "Message cannot be blank" },
            }));
        } else {
            setState((prev) => ({
                ...prev,
                Message: data.body,
                Media: data?.media,
                MessageLength: data.bodyLength,
                errors: { ...prev.errors, Message: "" },
                charLimit: data.characterLimit
            }));
        }
    };

    // useEffect(() => {
    //     if (Templates.length === 0) {
    //         LoadTemplates(dispatch);
    //     }
    // }, [])


    return (
        <div className="w-fill">
            {IsMobileDevice ?
                <div className={`${IsDarkMode ? "bg-color-sidebar-bg" : 'paper-background'} o-x-hidden w-fill h-v-100`}>
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex p-2'>
                            {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => props.OnClose(false)} /></span>}
                            <span className={`h1 my-auto color-add-details-title mr-auto`}>{state.Title}</span>
                        </div>
                    </Grid>
                    <form
                        noValidate
                        autoComplete="no"
                        onSubmit={formSubmit}
                        className="m-2 h-v-65"
                    >
                        <Grid container direction="row" spacing={3} className="mt-2">
                            <Grid item xs={12}>
                                <TextField autoFocus
                                    name="Name"
                                    placeholder="Rule Name"
                                    label="Rule Name"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={state.Name}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Name}
                                </FormHelperText>
                            </Grid>

                            {state.Type === RuleType.AUTO_REPLY && <Grid item xs={12} >
                                <Autocomplete
                                    size="small"
                                    disableClearable
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={keywordtype}
                                    disabled
                                    getOptionLabel={(option) => option?.Name}
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setState((prev) => ({ ...prev, Type: value.Value, errors: { ...state.errors, Type: "" } }));
                                            valueRefresher(value)
                                        }
                                        else {
                                            setState((prev) => ({ ...prev, Type: undefined, errors: { ...state.errors, Type: "Type cannot be blank" } }));
                                        }
                                    }}
                                    value={keywordtype.find(x => x.Value === state.Type)
                                        || { Name: "", Value: -1 }
                                    }
                                    renderOption={(defaultprops, option, { selected }) => (
                                        <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                            {option?.Name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Type" name="Type" placeholder="type" required variant="outlined" />}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Type}
                                </FormHelperText>
                            </Grid>
                            }
                            {state.Type === RuleType.AUTO_REPLY &&
                                <Grid item xs={12} >
                                    <Autocomplete
                                        size="small"
                                        disableClearable
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={durationType}
                                        getOptionLabel={(option) => option?.Name}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, DurationType: value.Value }, errors: { ...state.errors, DurationType: "" } }));
                                                valueRefresher(value);
                                            }
                                            else {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, DurationType: undefined }, errors: { ...state.errors, DurationType: "Duration Type cannot be blank" } }));
                                            }
                                        }}
                                        value={durationType.find(x => x.Value === state.Duration?.DurationType)
                                            || { Name: "", Value: -1 }
                                        }
                                        renderOption={(defaultprops, option, { selected }) => (
                                            <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                                {option?.Name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Duration Type" name="DurationType" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {state.errors.DurationType}
                                    </FormHelperText>
                                </Grid>}
                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_DAILY &&
                                <Grid item xs={12} >
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow h4-regular p-0 m-0', tag: 'color-display-title bg-color-secondary', clearIndicator: 'd-none', inputRoot: 'color-primary' }}
                                        multiple
                                        options={weekDays}
                                        value={weekDays.filter((x: any) => state.Duration.Days.includes(x.value))}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.label}
                                        // getOptionSelected={(option, value) => option.value === value.value}
                                        filterOptions={(options: any[], params: any) => {
                                            if (weekDays.length > 0) {
                                                const filtered = Autofilter(options, params);
                                                return [{ label: "Select all", value: -1 }, ...filtered];
                                            } else if (weekDays.length === 0) {
                                                const filtered = Autofilter(options, params);
                                                return [...filtered];
                                            }
                                            else { return options; }
                                        }}
                                        onChange={handleSelectDaysChange}
                                        renderOption={optionRenderer}
                                        renderInput={inputRenderer}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    classes={{
                                                        deleteIcon: 'd-none', label: 'pr-0'

                                                    }}
                                                    label={option.label}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {state.errors.Days}
                                    </FormHelperText>
                                </Grid>}

                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_WEEKLY &&
                                <Grid item xs={12} >
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={weekDays}
                                        getOptionLabel={(option) => option?.label}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, Days: [value.value] }, errors: { ...state.errors, Days: "" } }));
                                            }
                                            else {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, Days: [] }, errors: { ...state.errors, Days: "Days cannot be blank" } }));
                                            }
                                        }}
                                        value={weekDays.find((x: any) => state.Duration.Days.includes(x.value))}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h2 p-2 d-flex justify-between w-p-90"}>
                                                {option?.label}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Select Day" name="Day" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.Days}
                                    </FormHelperText>
                                </Grid>}
                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_MONTHLY &&
                                <>   <Grid item xs={12}>
                                    <DateAndTimePicker handleChange={handleMonthDate} DateTime={state.MonthDate} TextLabel={"Select Date"} HideTime={true} FormatTextLabel={`MM DD YYYY`} FormatText={`MMMM Do YYYY`} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.MonthDate}
                                    </FormHelperText>
                                </Grid>

                                </>
                            }

                            {state.Type === RuleType.AUTO_REPLY && (state.Duration.DurationType !== RuleDurationType.FIXED_DURATION && state.Duration.DurationType !== RuleDurationType.ALWAYS) && <><Grid item xs={12}>
                                <ArrowTimePicker Value={state.Duration.StartDateTime} handleChange={handleStartTimeDate} TextLabel={"Select Start Time"} IsMobileDevice={IsMobileDevice} />
                                <FormHelperText className="h5 color-primary-danger t-align-right">
                                    {state.errors.StartTime}
                                </FormHelperText>
                            </Grid>
                                <Grid item xs={12}>
                                    <ArrowTimePicker handleChange={handleEndTimeDate} Value={state.Duration.EndDateTime} TextLabel={"Select end Time"} IsMobileDevice={IsMobileDevice} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.EndTime}
                                    </FormHelperText>
                                </Grid></>}

                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.FIXED_DURATION && <> <Grid item xs={10}>
                                <DateAndTimePicker handleChange={handleStartTimeDate} DateTime={state.Duration?.StartDateTime} TextLabel={"Select Start Date and Time"} />
                                <FormHelperText className="h5 color-primary-danger t-align-right">
                                    {state.errors.StartTime}
                                </FormHelperText>
                            </Grid>
                                <Grid item xs={2} className={`d-flex my-auto p-0`}>
                                    <Tooltip title='Reset Date' placement='bottom'>
                                        <button className={"my-auto d-flex c-pointer"} onClick={ResetStartDateTime}>
                                            {state.Duration.StartDateTime ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                        </button>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={10}>
                                    <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={state.Duration.EndDateTime} TextLabel={"Select End Date and Time"} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.EndTime}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={2} className="d-flex my-auto p-0">
                                    <Tooltip title='Reset Date' placement='bottom'>
                                        <button className={"d-flex my-auto"} onClick={ResetEndDateTime} >
                                            {state.Duration.EndDateTime ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                        </button>
                                    </Tooltip>

                                </Grid></>}

                            {state.Type === RuleType.KEYWORD && <Grid item xs={12} >
                                <TextField
                                    name="Keyword"
                                    placeholder="Enter Keyword"
                                    label="Keyword"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={state.Keyword}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Keyword}
                                </FormHelperText>
                            </Grid>}

                            <Grid item xs={12}>
                                <MessageComposer
                                    HandleClose={() => props.OnClose(false)}
                                    Message={state.Message}
                                    HandleChange={handleMessageChanges}
                                    IsNewMessage={true}
                                    IsAddRule={true}
                                    PhoneNumbers={state.PhoneNumbers}
                                    Limit={1}
                                    UnsubscribedCount={0} BlockedCount={0} IsGroupChat={false}
                                    TemplateErrorMessage={!state.Media?.length && state.errors.Message} IsCamPaign={false}
                                    MultiMedia={state.Media}
                                />
                            </Grid>
                            {state.Type === RuleType.KEYWORD && <Grid item xs={12} className=' py-0 '>
                                <div className='d-flex justify-between align-center settings-paper-border p-2 br-2'>
                                    <div className='h4-medium d-flex flex-direction'>
                                        <span>Collect Opt-in Consent</span>
                                        <span>When a customer texts this keyword, their opt-in status will be recorded.</span>
                                    </div>
                                    <div>
                                        <CustomSwitch
                                            checked={state.isKeyWordOptIn}
                                            onChange={(checked: boolean) => {
                                                setState((prev) => ({
                                                    ...prev, isKeyWordOptIn: checked,
                                                }))
                                            }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            }
                        </Grid>
                        <div className={`px-2 mt-auto py-2 `}>
                            <ButtonComponent Type="submit" Loading={state.IsLoading} ButtonLabel={buttonLabels.SAVE.toUpperCase()} ClassName={"w-p-100 justify-center mb-2 br-6"} Variant={state.IsUploading ? "disabled-btn-small" : "primary-btn-small"} />
                            <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={"w-p-100 justify-center br-6"} Variant={"secondary-btn-small"} />
                        </div>
                    </form>

                </div> :
                <Dialog
                    maxWidth="lg"
                    fullWidth={true}
                    disableEscapeKeyDown
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={props.Show}
                    // onClose={() => props.OnClose(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: `w-79 br-2 ${IsDarkMode ? "" : "dialogue-shadow"} ` }}
                >
                    <DialogTitle id="alert-dialog-title" className={`p-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                        <div className='d-flex align-center'>
                            <span className={"h2-regular color-display-title"}>{state.Title || buttonLabels.ADD_RULE}</span>
                            <Tooltip title='Close' placement='bottom-start'>
                                <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.OnClose(false)} />
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <div className={"bb-primary-background-pink-4 mx-2"}></div>
                    <DialogContent className={`p-2 o-x-hidden ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>

                        <Grid container direction="row" spacing={2}>
                            <Grid item xs={12}>
                                <TextField autoFocus
                                    name="Name"
                                    placeholder="Rule Name"
                                    label="Rule Name"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={state.Name}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Name}
                                </FormHelperText>
                            </Grid>

                            {state.Type === RuleType.AUTO_REPLY && <Grid item xs={6}>
                                <Autocomplete
                                    disabled
                                    size="small"
                                    disableClearable
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={keywordtype}
                                    getOptionLabel={(option: any) => option.Name}
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setState((prev) => ({ ...prev, Type: value.Value, errors: { ...prev.errors, Type: "" } }));
                                            valueRefresher(value);
                                        } else {
                                            setState((prev) => ({ ...prev, Type: undefined, errors: { ...prev.errors, Type: "Type cannot be blank" } }));
                                        }
                                    }}
                                    value={keywordtype.find(x => x.Value === state.Type) || { Name: "", Value: 1 }}
                                    renderOption={(defaultprops, option, { selected }) => (
                                        <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                            {option?.Name}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Type" name="Type" placeholder="type" required variant="outlined" />}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Type}
                                </FormHelperText>
                            </Grid>}


                            {state.Type === RuleType.AUTO_REPLY &&
                                <Grid item xs={6} >
                                    <Autocomplete
                                        size="small"
                                        disableClearable
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={durationType}
                                        getOptionLabel={(option) => option?.Name}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                if (value.Value === RuleDurationType.ALWAYS) {
                                                    setState((prev) => ({ ...prev, Duration: { ...state.Duration, DurationType: value.Value, StartDateTime: undefined, EndDateTime: undefined }, errors: { ...state.errors, DurationType: "" } }));
                                                } else {
                                                    setState((prev) => ({ ...prev, Duration: { ...state.Duration, DurationType: value.Value }, errors: { ...state.errors, DurationType: "" } }));
                                                }
                                                valueRefresher(value);
                                            }
                                            else {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, DurationType: undefined }, errors: { ...state.errors, DurationType: "Duration Type cannot be blank" } }));
                                            }
                                        }}
                                        value={durationType.find(x => x.Value === state.Duration?.DurationType)
                                            || { Name: "", Value: -1 }
                                        }
                                        renderOption={(defaultprops, option, { selected }) => (
                                            <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                                {option?.Name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Duration Type" name="DurationType" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {state.errors.DurationType}
                                    </FormHelperText>
                                </Grid>}
                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_DAILY &&
                                <Grid item xs={12} >
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow h4-regular p-0 m-0', tag: 'color-display-title bg-color-secondary', clearIndicator: 'd-none', inputRoot: 'color-primary' }}
                                        multiple
                                        options={weekDays}
                                        value={weekDays.filter((x: any) => state.Duration.Days.includes(x.value))}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.label}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        filterOptions={(options: any[], params: any) => {
                                            if (weekDays.length > 0) {
                                                const filtered = Autofilter(options, params);
                                                return [{ label: "Select all", value: -1 }, ...filtered];
                                            } else if (weekDays.length === 0) {
                                                const filtered = Autofilter(options, params);
                                                return [...filtered];
                                            }
                                            else { return options; }
                                        }}
                                        onChange={handleSelectDaysChange}
                                        renderOption={optionRenderer}
                                        renderInput={inputRenderer}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    classes={{
                                                        deleteIcon: 'd-none', label: 'pr-0'

                                                    }}
                                                    label={option.label}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {state.errors.Days}
                                    </FormHelperText>
                                </Grid>}

                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_WEEKLY &&
                                <Grid item xs={12} >
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={weekDays}
                                        getOptionLabel={(option) => option?.label}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, Days: [value.value] }, errors: { ...state.errors, Days: "" } }));
                                            }
                                            else {
                                                setState((prev) => ({ ...prev, Duration: { ...state.Duration, Days: [] }, errors: { ...state.errors, Days: "Days cannot be blank" } }));
                                            }
                                        }}
                                        value={weekDays.find((x: any) => state.Duration.Days.includes(x.value))}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"c-pointer h2 p-2 d-flex justify-between w-p-90"}>
                                                {option?.label}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Select Day" name="Day" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.Days}
                                    </FormHelperText>
                                </Grid>}
                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.REPEAT_MONTHLY &&
                                <>   <Grid item xs={6}>
                                    <DateAndTimePicker handleChange={handleMonthDate} DateTime={state.MonthDate} TextLabel={"Select Date"} HideTime={true} FormatTextLabel={`MM DD YYYY`} FormatText={`MMMM Do YYYY`} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.MonthDate}
                                    </FormHelperText>
                                </Grid>
                                    <Grid item xs={6}>
                                    </Grid>
                                </>
                            }

                            {state.Type === RuleType.AUTO_REPLY && (state.Duration.DurationType !== RuleDurationType.FIXED_DURATION && state.Duration.DurationType !== RuleDurationType.ALWAYS) && <><Grid item xs={6}>
                                <ArrowTimePicker Value={state.Duration.StartDateTime} handleChange={handleStartTimeDate} TextLabel={"Select Start Time"} IsMobileDevice={IsMobileDevice} />
                                <FormHelperText className="h5 color-primary-danger t-align-right">
                                    {state.errors.StartTime}
                                </FormHelperText>
                            </Grid>
                                <Grid item xs={6}>
                                    <ArrowTimePicker handleChange={handleEndTimeDate} Value={state.Duration.EndDateTime} TextLabel={"Select end Time"} IsMobileDevice={IsMobileDevice} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.EndTime}
                                    </FormHelperText>
                                </Grid></>}

                            {state.Type === RuleType.AUTO_REPLY && state.Duration.DurationType === RuleDurationType.FIXED_DURATION && <> <Grid item xs={5}>
                                <DateAndTimePicker handleChange={handleStartTimeDate} DateTime={state.Duration?.StartDateTime} TextLabel={"Select Start Date and Time"} />
                                <FormHelperText className="h5 color-primary-danger t-align-right">
                                    {state.errors.StartTime}
                                </FormHelperText>
                            </Grid>
                                <Grid item xs={1} className={`d-flex my-auto p-0`}>
                                    <Tooltip title='Reset Date' placement='bottom'>
                                        <div className={"my-auto d-flex c-pointer"} onClick={(e) => { e.preventDefault(); state.Duration.StartDateTime !== -1 && ResetStartDateTime() }} >
                                            {state.Duration.StartDateTime !== -1 ? <ResetIcon style={{ fill: '#fff' }} className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={5}>
                                    <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={state.Duration.EndDateTime} TextLabel={"Select End Date and Time"} />
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {state.errors.EndTime}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={1} className="d-flex my-auto p-0">
                                    <Tooltip title='Reset Date' placement='bottom'>
                                        <button className={"d-flex my-auto"} onClick={(e) => { e.preventDefault(); state.Duration.EndDateTime !== -1 && ResetEndDateTime() }} >
                                            {state.Duration.EndDateTime !== -1 ? <ResetIcon fill="black" className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                        </button>
                                    </Tooltip>
                                </Grid></>}

                            {state.Type === RuleType.KEYWORD && <Grid item xs={12} >
                                <TextField
                                    name="Keyword"
                                    placeholder="Enter Keyword"
                                    label="Keyword"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={state.Keyword}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.Keyword}
                                </FormHelperText>
                            </Grid>}
                            <Grid item xs={12} className=''>
                                <MessageComposer
                                    HandleClose={() => props.OnClose(false)}
                                    Message={state.Message}
                                    HandleChange={handleMessageChanges}
                                    IsNewMessage={true}
                                    IsAddRule={true}
                                    PhoneNumbers={state.PhoneNumbers}
                                    Limit={1} UnsubscribedCount={0} BlockedCount={0} IsGroupChat={false}
                                    TemplateErrorMessage={!state.Media?.length && state.errors.Message}
                                    IsCamPaign={false}
                                    MultiMedia={state.Media}
                                />
                            </Grid>
                            {state.Type === RuleType.KEYWORD && <Grid item xs={12} className=' py-0 '>
                                <div className='d-flex justify-between align-center settings-paper-border p-2 br-2'>
                                    <div className='h4-medium d-flex flex-direction'>
                                        <span>Collect Opt-in Consent</span>
                                        <span className='h5-regular'>When a customer texts this keyword, their opt-in status will be recorded.</span>
                                    </div>
                                    <div>
                                        <CustomSwitch
                                            checked={state.isKeyWordOptIn}
                                            onChange={(checked: boolean) => {
                                                setState((prev) => ({
                                                    ...prev, isKeyWordOptIn: checked,
                                                }))
                                            }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions className={`pb-2 pr-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                        <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1"} Variant={"secondary-btn-small"} />
                        <ButtonComponent Type={"submit"} OnClick={formSubmit} ButtonLabel={props.ButtonLabel || buttonLabels.SAVE} ClassName={"px-4"} Variant={(state.MessageLength > state.charLimit || state.IsUploading) ? "disabled-btn-small" : "primary-btn-small"} Loading={state.IsLoading || props.ShowLoader} />
                    </DialogActions>
                </Dialog >}
        </div>
    )
};

export default AddRuleComponent;
